import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { styled } from '@mui/material/styles';
import React from 'react';
import Colors from '../../colors';
import FullWidthModalButton from './Buttons/FullWidthModalButton';

const style = {
    width: '15rem',
    position: 'absolute',
    display: 'flex',
    flexDirection: 'column',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    border: `0.5px solid ${Colors.darkGray}`,
    boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
    borderRadius: '20px',
};

const ModalTitle = styled('h3')(({ theme }) => ({
    textAlign: 'center',
}));

function CheckInConfirmationModal(props) {
    const { firstName, lastName, open, setOpen, handleCheckOut, handleUnCheckIn, handleUnCheckOut, checkin, checkout } = props
    const handleClose = () => setOpen(false);

    return (
        <div>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <ModalTitle>{`${firstName} ${lastName}`}</ModalTitle>
                    {checkin && !checkout && <FullWidthModalButton color={Colors.red} label={'Check Out'} onClick={handleCheckOut} />}
                    {checkin && !checkout && <FullWidthModalButton color={Colors.blue} label={'Un-check In'} onClick={handleUnCheckIn} />}
                    {checkout && checkin && <FullWidthModalButton color={Colors.blue} label={'Un-check Out'} onClick={handleUnCheckOut} />}
                    <FullWidthModalButton color={Colors.mediumGray} label={'Cancel'} onClick={handleClose} />
                </Box>
            </Modal>
        </div>
    );
}

export default CheckInConfirmationModal